import { Divider, Flex } from '@chakra-ui/react';
import { Tab, TabList, TabPanel, TabPanels, Tabs, colors } from 'ui-components';
import { CreatorChannelMetrics } from '~/components/CreatorChannelMetrics';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { usePlatformMetrics } from '~/hooks/usePlatformMetrics';

import { PlatformCharts } from './PlatformCharts';

export const CreatorDemographics: React.FC = () => {
  const foamTalentRecordChannelMetricsFlags = useFeature(
    FEATURE_FLAGS.foamTalentRecordChannelMetrics,
  );
  const { platformsToShow } = usePlatformMetrics({});

  return (
    <section>
      <Tabs>
        <TabList>
          {platformsToShow.map((platform) => (
            <Tab key={platform} trackId={`tab-${platform}`}>
              {platform}
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {platformsToShow.map((platform) => (
            <TabPanel key={platform}>
              <Flex direction="column" gap={6}>
                <PlatformCharts platform={platform} />
                {foamTalentRecordChannelMetricsFlags.isEnabled && (
                  <CreatorChannelMetrics platform={platform} />
                )}
              </Flex>
            </TabPanel>
          ))}
        </TabPanels>
        <Divider mt={6} mb={3} color={colors.primary[100]} />
      </Tabs>
    </section>
  );
};
